// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
}
.modal-footer {
  padding: 2px !important;
}
.grid {
  grid-template-columns: repeat(2, auto);
}
.add-new-partner {
  color: #a29ffa;
  padding-top: 10px;
  padding-left: 75%;
}
`, "",{"version":3,"sources":["webpack://./src/app/pms-management/dialogs/add-pms-user/add-pms-user.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;AADF;AAGA;EACI,aAAA;AADJ;AAIA;EACI,yBAAA;EACA,uBAAA;AAFJ;AAAA;EAKO,0BAAA;EACA,gBAAA;AAFP;AAJA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AAFP;AAMA;EACI,uBAAA;AAJJ;AAOA;EACI,sCAAA;AALJ;AAQA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AANJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.grid {\n    grid-template-columns: repeat(2, auto);\n}\n\n.add-new-partner{\n    color: @brpurple;\n    padding-top: 10px;\n    padding-left: 75%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
